export default __webpack_public_path__ + "static/media/indicesImg.df62e074.webp";